module.exports = __webpack_public_path__ + "static/media/digg.69fdfe89.svg";